import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import { getBreadCrumbLabels, getBreadCrumbLabelsLeft } from '../../selectors';
import './BreadCrumb.scss';
import routes from '../../routes';

class BreadCrumb extends Component {
    render() {
        const { pathname } = this.props.location;
        const currentPath = pathname.split('/');
        return (
            <div className="row d-none d-sm-flex pt-3 ml-3 breadcrumb-adj">
                <div className="col-6 d-flex p-0 justify-content-start" >
                    <div className="nav d-none d-lg-flex dashboard-quick-link">
                        <div className="nav-item"><a className="nav-link font-weight-bold">
                            {getBreadCrumbLabelsLeft(currentPath[3]) == "Goals" ? "Goals" : getBreadCrumbLabelsLeft(currentPath[3]) == "Unmapped Campaign" ? "Unmapped Campaign" : getBreadCrumbLabelsLeft(currentPath[2])}
                            {currentPath[3] != 'goals-list' && currentPath[3] != 'unmapped-campaign' && currentPath[3] && getBreadCrumbLabelsLeft(currentPath[3]) && ` ::  ${getBreadCrumbLabelsLeft(currentPath[3])}`}
                            {currentPath[4] && getBreadCrumbLabelsLeft(currentPath[4]) && ` :: ${getBreadCrumbLabelsLeft(currentPath[4])}`}
                        </a>
                        </div>
                    </div>
                </div>
                {/* <div classNaxe="col-12 d-flex p-0 justify-content-end">
                    <div className="nav d-none justify-content-end pr-3 d-lg-flex dashboard-quick-link">
                        <div className="nav-item"><a className="nav-link fs-2">
                            {currentPath[3] != undefined ? getBreadCrumbLabels(currentPath[2]) == "Ro" ? "RO" : getBreadCrumbLabels(currentPath[2]) : ""}
                            {currentPath[3] && getBreadCrumbLabels(currentPath[3]) && ` / ${getBreadCrumbLabels(currentPath[3])}`}
                            {currentPath[3] != undefined &&currentPath[4] && getBreadCrumbLabels(currentPath[4]) && ` / ${getBreadCrumbLabels(currentPath[4])}`}
                        </a>
                        </div>
                    </div>
                </div> */}
                <div className="col-6 d-flex p-0 pr-4 justify-content-end">
                    <div className="nav d-none d-lg-flex dashboard-quick-link">
                        <div className="nav-item">
                            <Link className="nav-link  text-primary " id="firstBred" to={`/${routes.mainRoute + '/' + currentPath[2] + (currentPath[3] == routes.containers.unmappedCampaign ? '/unmapped-campaign':'')}`}>
                                {currentPath[3] != undefined ? getBreadCrumbLabels(currentPath[3]) == "Goals" ? "Goals" : getBreadCrumbLabelsLeft(currentPath[3]) == "Unmapped Campaign" ? "Unmapped Campaign" :  getBreadCrumbLabels(currentPath[2]) : ""}
                            </Link>

                            {
                                currentPath[3] != 'goals-list' && currentPath[3] != 'unmapped-campaign' &&

                                <Link className="nav-link  text-primary" id="secondBre" to={`/${routes.mainRoute + '/' + currentPath[2] + '/' + currentPath[3]}`}>
                                    {currentPath[3] != undefined ? ` / ${getBreadCrumbLabels(currentPath[3])}` : ""}
                                </Link>

                            }


                            <a className="nav-link" id="thirdBred">
                                {currentPath[3] != undefined && currentPath[4] && getBreadCrumbLabels(currentPath[4]) && `/ ${getBreadCrumbLabels(currentPath[4])}`}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            // <div className="row d-none d-sm-flex">
            //     <div className="col-12 d-flex pb-2 justify-content-end">
            //         <div className="nav d-none d-lg-flex dashboard-quick-link">
            //             {/* <div className="nav-item"><a className="nav-link">Login</a></div> */}
            //             <div className="nav-item"><a className={`nav-link ${!(currentPath[3] && getBreadCrumbLabels(currentPath[3])) && 'font-weight-bold'}`}>
            //                 {getBreadCrumbLabels(currentPath[2])}
            //             </a>
            //             </div>
            //             {(currentPath[3] && getBreadCrumbLabels(currentPath[3])) &&
            //                 <div className="nav-item"><a className={`nav-link ${!(currentPath[4] && getBreadCrumbLabels(currentPath[4])) && 'font-weight-bold'}`}>
            //                     {` ${getBreadCrumbLabels(currentPath[3])}`}
            //                 </a>
            //                 </div>}
            //             {(currentPath[4] && getBreadCrumbLabels(currentPath[4])) &&
            //                 <div className="nav-item"><a className="nav-link font-weight-bold">
            //                     {` ${getBreadCrumbLabels(currentPath[4])}`}
            //                 </a>
            //                 </div>}
            //         </div>
            //     </div>
            // </div>
        );
    }
}

export default withRouter(BreadCrumb);